module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-cleaning-en-GB-a538cbfc471f4112d64cac6115b07cac.png";